module.exports = __webpack_public_path__ + "static/media/Service2image.63e667b8.svg";